import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=2e6c9fd8"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./SidebarComponent.vue?vue&type=style&index=0&id=2e6c9fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports